module.exports = __webpack_public_path__ + "img/12.6ec701e0.jpg";